import React from 'react';

import { Svg } from '@lglp/components';

import styles from './DropDownArrowIcon.module.scss';

export enum BounceDirection {
  TOP,
  LEFT,
  RIGHT,
  BOTTOM,
}

const DropDownArrowIcon: React.FC<DropDownArrowIconProps> = (props) => {
  const { bounceDirection, className, ...rest } = props;

  let bounceClassName = '';
  switch (bounceDirection) {
    case BounceDirection.TOP:
      bounceClassName = styles.bounceTop;
      break;
    case BounceDirection.BOTTOM:
      bounceClassName = styles.bounceBottom;
      break;
    case BounceDirection.LEFT:
      bounceClassName = styles.bounceLeft;
      break;
    case BounceDirection.RIGHT:
      bounceClassName = styles.bounceRight;
      break;
    default:
      break;
  }

  return (
    <Svg
      className={[styles.dropDownArrowIcon, bounceClassName, className]}
      viewBox="0 0 26.52 13.24"
      {...rest}
    >
      <path
        className="drop-down-arrow-1"
        d="M.53.53L12 12a1.85 1.85 0 0 0 2.61 0L26 .53"
      />
    </Svg>
  );
};

type DropDownArrowIconProps = {
  bounceDirection?: BounceDirection;
  className?: string;
};

export default DropDownArrowIcon;
